import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Table,
  Select,
  Drawer,
  notification,
  Breadcrumb,
  Tag,
  Modal,
  Spin,
} from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleTwoTone,
} from '@ant-design/icons';
import _ from 'lodash';
import './User.less';
import API from '../../utils/Api';

const { Search } = Input;
const { Option } = Select;

const User = () => {
  const myApi = new API({});
  myApi.createEntity({ name: 'user' });
  myApi.createEntity({ name: 'role' });
  myApi.createEntity({ name: 'klapp' });

  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [role, setRoleData] = useState(null);
  const [userData, setUserData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [visbleModal, setModalVisble] = useState(false);
  const [tittle, setTittle] = useState('');
  const [updateButton, setButton] = useState(false);
  const [hidePassword, setHidePassword] = useState(false);
  const [updateID, setKey] = useState('');
  const [passkey, setPassword] = useState();
  const [reqRole] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const fetchData = () => {
    setLoading(true);
    const apiArray = [
      myApi.endpoints.user.getAll(),
      myApi.endpoints.role.getAll(),
      myApi.endpoints.klapp.getAll(),
    ];
    Promise.all(apiArray)
      .then((res) => {
        const roleDetails = res[1].data.filter(res => res.role !== "super admin");
        const userDetails = res[0].data.filter((resp) => resp.user_role.role_id !== 1);
        setUserData(userDetails);
        setSearchData(userDetails);
        setRoleData(roleDetails);
        setProductData(res[2].data);
        setLoading(false);
      })
      .catch((err) =>
        notification.error({ message: `Failed to load the data` })
      );
  };

  useEffect(() => {
    fetchData();
  }, []);

  const saveProduct = (values) => {
    setDisabled(true);
    myApi.endpoints.klapp
      .create(values)
      .then((res) => {
        setDisabled(false);
        if (res.data) {
          setProductData([...productData, res.data]);
          notification.success({ message: 'Project added successfully.' });
          setModalVisble(false);
        } else {
          notification.error({ message: 'Failed to add Project.' });
          setModalVisble(false);
          setDisabled(false);
        }
      })
      .catch(() => {
        notification.error({ message: 'Failed to add Project.' });
        setModalVisble(false);
      });
  };

  const onFinish = (values) => {
    setDisabled(true);
    const emailAddress = values.email_address;
    values.appData = values.appArr.map((resp) => ({
      app_id: resp,
    }));
    const userName = userData.map((x) => x.email_address.toLowerCase());
    const email = _.compact(
      userData.map((data) => {
        if (updateID !== data.id) {
          return data.email_address.toLowerCase();
        }
      })
    );
    if (updateButton && !email.includes(emailAddress.toLowerCase())) {
      values.id = updateID;
      values.password = _.get(values, 'password', passkey);
      myApi.endpoints.user.update(values).then((res) => {
        if (res.data) {
          notification.success({ message: 'Updated successfully.' });
          setDisabled(false);
          setVisible(false);
          form.resetFields();
          fetchData();
        } else notification.error({ message: 'Failed to update the user' });
      });
    } else if (!userName.includes(emailAddress.toLowerCase())) {
      myApi.endpoints.user.create(values).then((res) => {
        if (res.data) {
          notification.success({ message: 'User created successfully.' });
          setDisabled(false);
          setVisible(false);
          form.resetFields();
          fetchData();
        } else notification.error({ message: 'Failed to create the user.' });
      });
    } else notification.error({ message: 'Email already exist!' });
  };

  const showDrawer = () => {
    setTittle('Create user');
    setVisible(true);
    setButton(false);
    setHidePassword(true);
  };

  const showModal = () => {
    setModalVisble(true);
  };

  const onClose = () => {
    setVisible(false);
    form.resetFields();
  };

  const globalSearch = (e) => {
    let { value } = e.target;
    let filteredData = [];
    value = value.toString().toLowerCase();
    if (!value) {
      filteredData.push(...searchData);
    } else {
      filteredData = searchData.filter((res) =>
        Object.keys(res).some(
          (resp) =>
            res[resp] && res[resp].toString().toLowerCase().includes(value)
        )
      );
    }
    setUserData(filteredData);
  };


  const handleCancel = () => {
    setModalVisble(false);
  };

  const handleEdit = (data, values) => {
    setKey(values.id);
    setVisible(true);
    setButton(true);
    setHidePassword(false);
    setPassword(values.password);
    values.role_id = _.get(values, "user_role.role_id", "");
    values.appArr = _.map(_.get(values, "user_kl_app", []), "app_id");
    form.setFieldsValue(_.omit(values, ['password']));
    setTittle('Edit User');
  };

  const handleDelete = (e, key) => {
    myApi.endpoints.user.delete({ id: key.id }).then((res) => {
      if (res.data) {
        notification.success({ message: 'User deleted successfully' });
        fetchData();
      } else notification.error({ message: 'Failed to delete the user' });
    });
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      fixed: 'left',
    },
    {
      title: 'Email',
      dataIndex: 'email_address',
      key: 'email_address',
      width: 250,
      fixed: 'left',
    },
    {
      title: 'Project Name',
      dataIndex: 'user_kl_app',
      width: 175,
      fixed: 'left',
      render: (tags) => (
        <p style={{ marginBottom: 0 }}>
          {tags.map((item) => `${item.kl_app.app_name}`).join(',')}
        </p>
      ),
    },
    {
      title: 'Action',
      width: 100,
      align: 'right',
      render: (a) => (
        <span className='edit-box'>
          <Tag color='green' onClick={(e) => handleEdit(e, a)}>
            <EditOutlined />
          </Tag>
          &nbsp;
          <Tag color='red' onClick={(e) => handleDelete(e, a)}>
            <DeleteOutlined />
          </Tag>
        </span>
      ),
    },
  ];
  return (
    <Spin spinning={loading}>
      <div className='search-container'>
        <div>
          <Breadcrumb>
            <Breadcrumb.Item> User Management</Breadcrumb.Item>
            <Breadcrumb.Item>User</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div>
          <Search
            placeholder='Search'
            onChange={globalSearch}
            className='custom-search'
          />
        </div>
        <div>
          <Button type='primary' onClick={showDrawer}>
            <PlusCircleTwoTone /> Add User
          </Button>
        </div>
      </div>
      <div className='box'>
        <div className='box__header'>
          <h3 className='box-title'>User Lists</h3>
        </div>
        <div className='box__content p-0'>
          <Table
            className='grid-table'
            columns={columns}
            dataSource={userData}
          />
        </div>
      </div>
      <Drawer
        title={tittle} width={700}
        onClose={onClose}
        visible={visible}
        maskClosable={false}
      >
        <Spin spinning={disabled}>
          <div style={{ textAlign: 'right' }}>
            <Button type='primary' onClick={showModal}>
              <PlusCircleTwoTone /> Add Project
              </Button>
          </div>
          <Form
            form={form}
            className='user-form'
            layout='vertical'
            onFinish={onFinish}
            initialValues={{ coverage_list: [] }}
          >
            <div className='warranty-form__grid'>
              <Form.Item
                label='Name'
                name='name'
                rules={[
                  {
                    required: true,
                    message: 'Please enter your name!',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name='role_id'
                label='User Type'
                hasFeedback
                rules={[
                  { required: true, message: 'Please select your User Type!' },
                ]}
              >
                <Select
                  placeholder='Please select'
                  disabled={reqRole}
                >
                  {role &&
                    role.map((roleName) => (
                      <Option key={roleName.id} value={roleName.id}>
                        {roleName.role}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
            <div className='warranty-form__grid'>
              <Form.Item
                name='appArr'
                label='Project'
                hasFeedback
                rules={[
                  { required: true, message: 'Please select your User Type!' },
                ]}
              >
                <Select
                  placeholder='Please select'
                  disabled={reqRole}
                  mode="multiple"
                >
                  {productData &&
                    productData.map((productName) => (
                      <Option key={productName.id} value={productName.id}>
                        {productName.app_name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                label='Email'
                name='email_address'
                rules={[
                  {
                    required: true,
                    message: 'Please enter your email!',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className='warranty-form__grid'>
              <Form.Item
                label='Password'
                name='password'
                rules={[
                  {
                    required: hidePassword,
                    message: 'Please enter your password!',
                  },
                  { min: 5, message: 'password must be minimum 5 characters.' },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                name='confirm'
                label='Confirm Password'
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: hidePassword,
                    message: 'Please confirm your password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        new Error(
                          'The two passwords that you entered do not match!'
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
            </div>
            <Form.Item>
              <Button htmlType='submit' type='primary' disabled={disabled}>
                {disabled ? 'Submitting' : 'Submit'}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </Drawer>
      <Modal
        title='Add Project'
        visible={visbleModal}
        onCancel={handleCancel}
        footer={false}
        maskClosable={false}
        width={320}
      >
        <Form form={form1} layout='vertical' onFinish={saveProduct}>
          <Form.Item
            label='Enter Project '
            rules={[
              {
                required: true,
                message: 'please enter project name',
              },
            ]}
            name='app_name'
          >
            <Input placeholder='Project Name' />
          </Form.Item>
          <Form.Item style={{ 'margin-bottom': 0 }}>
            <Button htmlType='submit' type='primary'>
              Submit
                  </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Spin>
  );
};

export default User;
